
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'

import { mapActions } from 'vuex'

export default {
name: 'SportsTourPackageNotice',
components: {
Group,
XHeader,
Previewer,
},
data() {
return {
body: {},
imgList: [],
}
},
computed: {

},
methods: {
...mapActions(['showToast']),
generateImgList() {
const images = document.querySelectorAll('.sports-tour-package-notice-wrapper img')
return Array.from(images).map(img => ({
src: img.src,
w: img.getAttribute('data-width') || 600,
h: img.getAttribute('data-height') || 400,
}))
},
popUpImg(event) {
if (event.target.tagName === 'IMG') {
const idx = this.imgList.map(im => im.src).indexOf(event.target.src)
this.$refs.previewer.show(idx !== -1 ? idx : 0)
}
},
},
created() {
this.$http.get('/api/content/13').then((data) => {
this.body = data.body
this.imgList = this.generateImgList()
})
},
}



// WEBPACK FOOTER //
// ./client/components/SportsTour/SportsTourPackageNotice.vue